<div class="mt--100 data-table" *ngIf="authAdaptor.getStaffIdOrNull == undefined">
  <form [formGroup]="saveEmailForm" (ngSubmit)="onAddEmail()">
    <div class="block  payment-settings">
      <h3>General</h3>

      <div class="mt--150 form-toggle">
        <input
          [checked]="authAdaptor.user.getContact().fwdEmailConfirmation"
          (change)="toggleEmailForwarding()"
          type="checkbox"
          name="checkbox"
          class="form-toggle__input"
          data-cy="email-forwarding-toggle"
        >
        <span class="form-toggle__icon"></span>
        <label class="form-toggle__label">Forward all payment confirmations to a colleague</label>
      </div>

      <div class="mt--050 form-control payment-settings__form-control">
        <div class="grid-row grid-row--smg">
          <div class="grid-col--11">
            <input type="email" placeholder="Enter email address" class="form-input" formControlName="email" data-cy="email-forwarding-address">
          </div>
        </div>
      </div>

      <div class="mt--050 payment-settings__form-control">
        <button type="submit" class="text-button" data-cy="add-email">+ Add Email</button>
      </div>

      <div *ngFor="let email of emailAddresses()">
        <div class="mt--025 form-control payment-settings__form-control">
          <div class="grid-row grid-row--smg">
            <div class="grid-col">
              <input type="text" disabled placeholder="Enter email address" value="{{email}}" class="form-input">
            </div>
            <div class="grid-col grid-col--auto">
              <button type="button" class="button button--text" data-cy="delete-email" (click)="deleteEmail(email)">
                <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none"
                     stroke-linecap="round" stroke-linejoin="round" class="button__icon">
                  <polyline points="3 6 5 6 21 6"></polyline>
                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  <line x1="10" y1="11" x2="10" y2="17"></line>
                  <line x1="14" y1="11" x2="14" y2="17"></line>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
</form>
</div>
